export default function serializeOrderTransfer(orderTransfer) {
  return {
    ...orderTransfer,

    amount: orderTransfer.amount && orderTransfer.amount.value,
    currency: orderTransfer.amount && orderTransfer.amount.currency,
  };
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/serializers/serializeOrderTransfer.js